import { useApp } from 'contexts/app';
import { useViewport } from 'contexts/viewport';
import { useTranslation } from 'react-i18next';
import { Button, IconButton, ResponsiveDialog, Stack, Text } from 'shell/components';
import { getLanguageLevelText, getSuggestionLengthText, getToneText } from 'utils/helper';

const ViewFormativeDialog = ({ dialog, onClose }) => {
    const { open, submissionId } = dialog;

    const { studentSubmissions } = useApp();
    const { t } = useTranslation('assignment');
    const { device } = useViewport();

    const submission = studentSubmissions.find(({ id }) => id === submissionId);
    const submissionIndex = studentSubmissions.findIndex(({ id }) => id === submissionId);

    return (
        <ResponsiveDialog aria-labelledby={'dialog-title'} open={open} onClose={onClose}>
            <Stack sx={{ minWidth: device === 'mobile' ? '100%' : '400px' }} spacing={8}>
                <Stack spacing={5}>
                    <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                        <Text id={'dialog-title'} component={'h1'} variant={'h6'} weight={'semibold'}>
                            {t('draft-parameter-number', 'Draft {count} Parameters', { count: submissionIndex + 1 })}
                        </Text>
                        <IconButton
                            aria-label={'close'}
                            kind={'exit'}
                            size={'medium'}
                            variant={'square'}
                            onClick={onClose}
                        />
                    </Stack>
                    <Stack spacing={5}>
                        <Stack spacing={3}>
                            <Text weight={'medium'}>
                                {t('formative-feedback.parameter.1-topic', '1. What is my topic?')}
                            </Text>
                            <Text>{submission?.formative_snapshot?.ai_context}</Text>
                        </Stack>
                        {submission?.formative_snapshot?.ai_student_feedback_settings && (
                            <>
                                <Stack spacing={3}>
                                    <Text weight={'medium'}>
                                        {t('formative-feedback.parameter.2-length', '2. Length of Each Suggestion')}
                                    </Text>
                                    <Text>
                                        {getSuggestionLengthText(
                                            submission.formative_snapshot.ai_student_feedback_settings
                                                .suggestion_length,
                                            t
                                        )}
                                    </Text>
                                </Stack>
                                <Stack spacing={3}>
                                    <Text weight={'medium'}>
                                        {t('formative-feedback.parameter.3-language', '3. Language Level')}
                                    </Text>
                                    <Text>
                                        {getLanguageLevelText(
                                            submission.formative_snapshot.ai_student_feedback_settings.language_level,
                                            t
                                        )}
                                    </Text>
                                </Stack>
                                <Stack spacing={3}>
                                    <Text weight={'medium'}>{t('formative-feedback.parameter.4-tone', '4. Tone')}</Text>
                                    <Text>
                                        {getToneText(
                                            submission.formative_snapshot.ai_student_feedback_settings.tone,
                                            t
                                        )}
                                    </Text>
                                </Stack>
                            </>
                        )}
                    </Stack>
                </Stack>
                <Button sx={{ alignSelf: 'flex-end' }} onClick={onClose}>
                    {t('common:controls.close', 'Close')}
                </Button>
            </Stack>
        </ResponsiveDialog>
    );
};

export default ViewFormativeDialog;
